
// lazy images captured before their loader ran (judge.me gallery etc.)
document.querySelectorAll('img[data-src]:not([src])').forEach(function (i) { i.src = i.getAttribute('data-src'); });

// reveal-on-scroll: same mechanics as the theme (animate--hidden -> animate--shown)
(function () {
  var sections = document.querySelectorAll('.animate-section');
  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.remove('animate--hidden'); s.classList.add('animate--shown'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.remove('animate--hidden');
        e.target.classList.add('animate--shown');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  sections.forEach(function (s) { io.observe(s); });
})();

// sticky header on-scroll-up
(function () {
  var section = document.querySelector('.section-header');
  if (!section) return;
  var headerBottom = section.offsetTop + section.offsetHeight;
  var currentScrollTop = 0;
  window.addEventListener('scroll', function () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop <= headerBottom) {
      section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'scrolled-past-header');
    } else if (scrollTop > currentScrollTop) {
      section.classList.add('scrolled-past-header');
      section.classList.remove('animate');
      requestAnimationFrame(function () {
        section.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      });
    } else if (scrollTop < currentScrollTop) {
      section.classList.add('scrolled-past-header');
      requestAnimationFrame(function () {
        section.classList.remove('shopify-section-header-hidden');
        section.classList.add('shopify-section-header-sticky', 'animate');
      });
    }
    currentScrollTop = scrollTop;
  }, false);
})();

// menu drawer (burger)
(function () {
  var drawer = document.getElementById('Details-menu-drawer-container');
  if (!drawer) return;
  var summary = drawer.querySelector('summary');

  function openDrawer() {
    drawer.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { drawer.classList.add('menu-opening'); });
    });
    document.body.classList.add('overflow-hidden-mobile');
  }

  function closeDrawer() {
    drawer.classList.remove('menu-opening');
    drawer.querySelectorAll('details[open]').forEach(function (d) {
      if (d !== drawer) { d.classList.remove('menu-opening'); d.removeAttribute('open'); }
    });
    summary.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-mobile');
    setTimeout(function () { drawer.removeAttribute('open'); }, 400);
  }

  summary.addEventListener('click', function (e) {
    e.preventDefault();
    drawer.classList.contains('menu-opening') ? closeDrawer() : openDrawer();
  });
  var closeBtn = drawer.querySelector('.menu-drawer__close-menu-btn');
  if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
  document.addEventListener('keyup', function (e) { if (e.code === 'Escape') closeDrawer(); });

  drawer.querySelectorAll('.menu-drawer__menu details').forEach(function (d) {
    var s = d.querySelector('summary');
    s.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.classList.contains('menu-opening')) {
        d.classList.remove('menu-opening');
        s.setAttribute('aria-expanded', 'false');
        setTimeout(function () { d.removeAttribute('open'); }, 400);
      } else {
        d.setAttribute('open', '');
        s.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { d.classList.add('menu-opening'); });
        });
      }
    });
    var back = d.querySelector('.menu-drawer__close-button');
    if (back) back.addEventListener('click', function (e) {
      e.preventDefault();
      d.classList.remove('menu-opening');
      setTimeout(function () { d.removeAttribute('open'); }, 400);
    });
  });
})();

// product buy box: wire captured bundle bars to the store's real variants
(function () {
  var variants = window.__REALVARIANTS;
  if (!variants || !variants.length) return;
  var bars = [].slice.call(document.querySelectorAll('.kaching-bundles__bar'));
  if (!bars.length) return;

  // purchase bars carry a price element; the subscribe/refill bar does not
  var buyBars = bars.filter(function (b) { return b.querySelector('.kaching-bundles__bar-price'); });
  var subBars = bars.filter(function (b) { return !b.querySelector('.kaching-bundles__bar-price'); });
  subBars.forEach(function (b) { b.style.display = 'none'; }); // no selling plan set up yet

  // hide the Loop subscription widget (no subscription plan configured on the product)
  document.querySelectorAll('.loop-widget-container').forEach(function (el) { el.style.display = 'none'; });

  // strip stale Kaching bundle payload so the form adds one clean variant, not a competitor bundle
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.querySelectorAll('[name^="items["], [name="selling_plan"], [name="properties[__kaching_bundles]"]')
      .forEach(function (el) { el.remove(); });
  });

  function setFormVariant(id) {
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (inp) {
      inp.value = String(id);
    });
  }

  function setAtcPrice(priceText) {
    document.querySelectorAll('[class*="main-atc-price-span"]').forEach(function (el) {
      el.textContent = priceText;
    });
  }

  function selectVariant(v) {
    setFormVariant(v.id);
    setAtcPrice(v.price);
  }

  buyBars.forEach(function (bar, k) {
    var v = variants[k];
    if (!v) { bar.style.display = 'none'; return; }
    bar.dataset.realVariant = v.id;
    var priceEl = bar.querySelector('.kaching-bundles__bar-price');
    var fullEl = bar.querySelector('.kaching-bundles__bar-full-price');
    if (priceEl) priceEl.textContent = v.price;
    if (fullEl) {
      if (v.hasCompare) { fullEl.textContent = v.compare; fullEl.style.display = ''; }
      else { fullEl.style.display = 'none'; }        // no compare-at set -> hide strike
    }
    bar.addEventListener('click', function () {
      buyBars.forEach(function (b) { b.classList.remove('kaching-bundles__bar--selected'); });
      bar.classList.add('kaching-bundles__bar--selected');
      selectVariant(v);
    });
  });

  // initial selection: first available bar
  var initIdx = 0;
  for (var i = 0; i < buyBars.length; i++) {
    if (variants[i] && variants[i].available) { initIdx = i; break; }
  }
  buyBars.forEach(function (b) { b.classList.remove('kaching-bundles__bar--selected'); });
  if (buyBars[initIdx]) buyBars[initIdx].classList.add('kaching-bundles__bar--selected');
  if (variants[initIdx]) selectVariant(variants[initIdx]);
})();

// product gallery: click a thumbnail to swap the main image
(function () {
  var thumbs = document.querySelectorAll('.cpg__thumb');
  if (!thumbs.length) return;
  var main = document.getElementById('cpg-main');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (main) { main.src = t.getAttribute('data-full'); main.srcset = ''; }
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });
})();
